import Config from 'config';

export default class AuthDataStorage {
    constructor() {
    }

    setUserAsLoggedIn(response) {
        sessionStorage.setItem("userData", JSON.stringify(response.userData));
        sessionStorage.setItem("groupData", JSON.stringify(response.groupData));
        sessionStorage.setItem("loggedIn", true);
        sessionStorage.setItem("Auth-Token", true);

        localStorage.setItem("userData", JSON.stringify(response.userData));
        localStorage.setItem("groupData", JSON.stringify(response.groupData));
        localStorage.setItem("loggedIn", true);
        localStorage.setItem("Auth-Token", true);
    }

    logout() {
        sessionStorage.clear();
        localStorage.removeItem("userData");
        localStorage.removeItem("groupData");
        localStorage.removeItem("loggedIn");
        localStorage.removeItem("Auth-Token");
    }

    getLoggedIn() {
        let loggedIn = sessionStorage.getItem("loggedIn") || localStorage.getItem("loggedIn");
        return loggedIn;
    }

    getUserData() {
        return sessionStorage.getItem("userData") || localStorage.getItem("userData");
    }

    setUserData(data) {
        sessionStorage.setItem("userData", data);
        localStorage.setItem("userData", data);
    }

    getGroupData() {
        return sessionStorage.getItem("groupData") || localStorage.getItem("groupData");
    }

    setItem(key, value) {
        sessionStorage.setItem(key, value);
        localStorage.setItem(key, value);
    }

    refreshDataFromServer(callback) {
        let userData = JSON.parse(this.getUserData());
        if (!userData) {
            if (typeof callback == "function") {
                callback();
            }
            return false;
        }
        var request = new XMLHttpRequest();
        request.onreadystatechange = function() {
            if (request.readyState == 4) {
                if (request.status !== 200) {
                    return this.loginError('Their was an error logging in please try again.');
                }

                var response = JSON.parse(request.responseText);
                if (response.success) {
                    if (response.userData) {
                        this.setUserData(JSON.stringify(response.userData));
                    }
                }
                if (typeof callback === 'function') {
                    callback();
                }
            }
        }.bind(this);

        request.open("POST", Config.BACKEND_URL + '/getCurrentUserData');
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        request.setRequestHeader("auth-token", userData.token);
        request.send();
    }
}



// WEBPACK FOOTER //
// ./src/AuthDataStorage.js